var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaktus404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128.059,
    height: 70.308,
    viewBox: "0 0 128.059 70.308",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_404-v5",
    "data-name": "404-v5",
    transform: "translate(-98.165 -130)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_45",
    "data-name": "Pfad 45",
    d: "M0,0,4.231,4.231",
    transform: "translate(122.046 143.046)",
    fill: "none",
    stroke: "#f7b01e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46",
    "data-name": "Pfad 46",
    d: "M0,0,4.936,2.821",
    transform: "translate(123.456 140.225)",
    fill: "none",
    stroke: "#f7b01e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_47",
    "data-name": "Pfad 47",
    d: "M0,0,2.116,3.526",
    transform: "translate(119.93 145.161)",
    fill: "none",
    stroke: "#f7b01e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15",
    "data-name": "Pfad 15",
    d: "M5.867,12.822l6.44,11.154,3.354-4.839L10.478,10.16l6.837.588-3.092-5.3-6.643-.3L4.607,0,0,2.66l4.4,7.58Z",
    transform: "translate(163.161 181.21) rotate(-150)",
    fill: "#32bee1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_27",
    "data-name": "Pfad 27",
    d: "M3.357,1.635,4.311,0,2.4.315l-.762,1.32L.793,3.1,0,4.472l.855,1.5L2.081,3.84Z",
    transform: "translate(170.63 158.942) rotate(-30)",
    fill: "#32bee1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_26",
    "data-name": "Pfad 26",
    d: "M5.867,11.154,12.307,0l3.354,4.839L11.583,11.9,18.2,11.7l-2.871,4.918-6.643.3L4.607,23.976,0,21.317l4.384-7.592Z",
    transform: "translate(154.693 158.68) rotate(-30)",
    fill: "#43ccad",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13",
    "data-name": "Pfad 13",
    d: "M3.357,4.336l.954,1.635L2.4,5.667,1.635,4.336.793,2.874,0,1.5.855,0,2.081,2.131Z",
    transform: "translate(155.8 168.088) rotate(-150)",
    fill: "#43ccad",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_55",
    "data-name": "Pfad 55",
    d: "M0,0H14.089",
    transform: "translate(159.107 179.5)",
    fill: "none",
    stroke: "#88898a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_56",
    "data-name": "Pfad 56",
    d: "M0,0H9",
    transform: "translate(166.151 182.5)",
    fill: "none",
    stroke: "#88898a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_52",
    "data-name": "Pfad 52",
    d: "M0,0H26.849",
    transform: "translate(118.651 192.86)",
    fill: "none",
    stroke: "#88898a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15-2",
    "data-name": "Pfad 15",
    d: "M9.413,20.571,19.745,38.466,25.126,30.7,16.811,16.3l10.969.943-4.96-8.5L12.163,8.265,7.391,0,0,4.267,7.061,16.429Z",
    transform: "translate(195.291 192.326) rotate(-150)",
    fill: "#32bee1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_27-2",
    "data-name": "Pfad 27",
    d: "M5.386,2.623,6.916,0,3.846.505,2.623,2.623,1.272,4.968,0,7.174l1.371,2.4L3.339,6.161Z",
    transform: "translate(207.275 156.6) rotate(-30)",
    fill: "#32bee1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_26-2",
    "data-name": "Pfad 26",
    d: "M9.413,17.895,19.745,0l5.381,7.763L18.582,19.1,29.2,18.768l-4.606,7.89-10.657.475L7.391,38.466,0,34.2,7.033,22.018Z",
    transform: "translate(181.706 156.179) rotate(-30)",
    fill: "#43ccad",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13-2",
    "data-name": "Pfad 13",
    d: "M5.386,6.956l1.53,2.623L3.857,9.092,2.623,6.956,1.272,4.611,0,2.4,1.371,0,3.339,3.418Z",
    transform: "translate(183.483 171.273) rotate(-150)",
    fill: "#43ccad",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_57",
    "data-name": "Pfad 57",
    d: "M0,0H20.9",
    transform: "translate(190.5 188.359)",
    fill: "none",
    stroke: "#88898a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_58",
    "data-name": "Pfad 58",
    d: "M0,0H12.449",
    transform: "translate(202.5 192.789)",
    fill: "none",
    stroke: "#88898a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_59",
    "data-name": "Pfad 59",
    d: "M0,0H3.994",
    transform: "translate(213.5 196.334)",
    fill: "none",
    stroke: "#88898a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_53",
    "data-name": "Pfad 53",
    d: "M0,0H13.893",
    transform: "translate(133.292 196.334)",
    fill: "none",
    stroke: "#88898a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pfad_44",
    "data-name": "Pfad 44",
    transform: "translate(109 130)",
    fill: "#f7b01e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.109470367431641 15.71894073486328 C 3.913590431213379 15.71894073486328 0.5000003576278687 12.3053503036499 0.5000003576278687 8.109470367431641 C 0.5000003576278687 3.913590431213379 3.913590431213379 0.5000003576278687 8.109470367431641 0.5000003576278687 C 12.3053503036499 0.5000003576278687 15.71894073486328 3.913590431213379 15.71894073486328 8.109470367431641 C 15.71894073486328 12.3053503036499 12.3053503036499 15.71894073486328 8.109470367431641 15.71894073486328 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8.109470367431641 1 C 4.189290046691895 1 1 4.189290046691895 1 8.109470367431641 C 1 12.02964973449707 4.189290046691895 15.21894073486328 8.109470367431641 15.21894073486328 C 12.02964973449707 15.21894073486328 15.21894073486328 12.02964973449707 15.21894073486328 8.109470367431641 C 15.21894073486328 4.189290046691895 12.02964973449707 1 8.109470367431641 1 M 8.109470367431641 0 C 12.588210105896 0 16.21894073486328 3.630730628967285 16.21894073486328 8.109470367431641 C 16.21894073486328 12.588210105896 12.588210105896 16.21894073486328 8.109470367431641 16.21894073486328 C 3.630730628967285 16.21894073486328 0 12.588210105896 0 8.109470367431641 C 0 3.630730628967285 3.630730628967285 0 8.109470367431641 0 Z",
    stroke: "none",
    fill: "#f7b01e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_48",
    "data-name": "Pfad 48",
    d: "M0,0,1.41,4.231",
    transform: "translate(116.404 144.456)",
    fill: "none",
    stroke: "#f7b01e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_50",
    "data-name": "Pfad 50",
    d: "M0,0,5.641,2.116",
    transform: "translate(122.751 136.699)",
    fill: "none",
    stroke: "#f7b01e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_49",
    "data-name": "Pfad 49",
    d: "M0,0,.705,2.821",
    transform: "translate(113.584 144.456)",
    fill: "none",
    stroke: "#f7b01e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_51",
    "data-name": "Pfad 51",
    d: "M0,0,5.641,1.41",
    transform: "translate(121.34 133.878)",
    fill: "none",
    stroke: "#f7b01e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_54",
    "data-name": "Pfad 54",
    d: "M0,0H6.268",
    transform: "translate(143.612 199.808)",
    fill: "none",
    stroke: "#88898a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15-3",
    "data-name": "Pfad 15",
    d: "M11.347,24.8,23.8,46.369l6.487-9.358L20.265,19.649l13.223,1.136-5.979-10.25L14.662,9.963,8.909,0,0,5.144,8.511,19.8Z",
    transform: "translate(127.166 196.937) rotate(-150)",
    fill: "#32bee1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_27-3",
    "data-name": "Pfad 27",
    d: "M6.492,3.162,8.337,0l-3.7.609L3.162,3.162,1.533,5.989,0,8.648l1.653,2.9,2.372-4.12Z",
    transform: "translate(141.612 153.871) rotate(-30)",
    fill: "#32bee1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_26-3",
    "data-name": "Pfad 26",
    d: "M11.347,21.571,23.8,0l6.487,9.358L22.4,23.021l12.8-.4-5.552,9.51L16.8,32.707,8.909,46.369,0,41.225,8.478,26.542Z",
    transform: "translate(110.789 153.363) rotate(-30)",
    fill: "#43ccad",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13-3",
    "data-name": "Pfad 13",
    d: "M6.492,8.385l1.845,3.162L4.649,10.96,3.162,8.385,1.533,5.558,0,2.9,1.653,0,4.025,4.12Z",
    transform: "translate(112.932 171.559) rotate(-150)",
    fill: "#43ccad",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_60",
    "data-name": "Pfad 60",
    d: "M0,0H3.044",
    transform: "translate(173.151 185.5)",
    fill: "none",
    stroke: "#88898a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_61",
    "data-name": "Pfad 61",
    d: "M-.544-2.714H1.723l.751.751.751-.751H5.4",
    transform: "translate(175.149 136.5)",
    fill: "none",
    stroke: "#88898a",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_62",
    "data-name": "Pfad 62",
    d: "M-.544-2.714H1.723l.751.751.751-.751H5.4",
    transform: "translate(179.445 137.728)",
    fill: "none",
    stroke: "#88898a",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_63",
    "data-name": "Pfad 63",
    d: "M-.544-2.714H1.723l.751.751.751-.751H5.4",
    transform: "translate(184.969 136.5)",
    fill: "none",
    stroke: "#88898a",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaktus404);
export default __webpack_public_path__ + "static/media/kaktus404.2a33adaf8018c50580c3e26cd83500fa.svg";
export { ForwardRef as ReactComponent };